import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { AppFeedbackService } from './core/app-feedback.service';
import { AppConfirmDialogComponent } from './shared/app-confirm-dialog.component';

@Component({
  selector: 'app-root',
  imports: [AppConfirmDialogComponent, CommonModule, RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  constructor(readonly feedback: AppFeedbackService) {}
}
